import {withStyles} from '@material-ui/core/styles'
import React from 'react'
import {
  TopToolbar,
  CreateButton,
  Datagrid,
  DateField,
  EditButton,
  List,
  TextField,
  ImageField,
  SelectField
} from 'react-admin'
import * as choices from './choices'

const styles = theme => ({
  title: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
  hiddenOnSmallScreens: {
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  }
})
const Actions = ({basePath,}) => (
  <TopToolbar>
    <CreateButton basePath={basePath}/>
  </TopToolbar>
)

export default withStyles(styles)(({classes, ...props}) => {
  return (
    <List {...props}
          actions={<Actions/>}
          bulkActionButtons={false}>
      <Datagrid>
        <TextField source="id" sortable={false}/>
        <ImageField source="image" sortable={false}/>
        <SelectField source="division" choices={choices.division} sortable={false}/>
        <DateField source="createdAt" locales='ko' showTime sortable={false}/>
        <EditButton/>
      </Datagrid>
    </List>
  )
})

